import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "scan-button"
  static values = { title: String }

  connect() {
    super.connect()
    this.#notifyBridgeOfConnect()
  }

  disconnect() {
    this.send("disconnect", {}, () => {})
    super.disconnect()
  }

  #notifyBridgeOfConnect() {
    const title = this.hasTitleValue ? this.titleValue : "Scan"

    this.send("connect", { title }, () => {
      this.element.click()
    })
  }
}
